export default "__VITE_ASSET__CINzAcaN__";